import React from 'react'
import ReactDOM from 'react-dom'
import { App } from '@LTIDashboard/App'

export function startLTIDashboard(data) {
  ReactDOM.render(<App data={data} />, document.getElementById('app'))
}
